export default __webpack_public_path__ + "img/63f0a5d175e86a16a4d3543f48dce0a6.svg";